/**
 * @description This file has methods to trigger analytic events for suggested recommendations feature
 */

import { ANALYTICS } from '../../constants/common';
import { trackFormInput } from './analyticEvents';

/**
 * @method trackSuggestedRecommendationsByCategory
 * @description tracks recommendation counts for each category
 * @param {Record<string, number>} categoryCounts - Object with category names as keys and recommendation counts as values
 * @example trackSuggestedRecommendationsByCategory({ 'Grammar': 3, 'Spelling': 2, 'Style': 5 })
 */
export const trackSuggestedRecommendationsByCategory = (
  categoryCounts: Record<string, number>
) => {
  let questionIndex = 1;
  Object.entries(categoryCounts).forEach(([categoryName, count]) => {
    trackFormInput(
      ANALYTICS.SUGGESTED_RECOMMENDATIONS_FORM_NAME,
      ANALYTICS.STEP,
      categoryName,
      count.toString(),
      questionIndex.toString()
    );
    questionIndex++;
  });
};

/**
 * @method trackSuggestedRecommendationsBySeverity
 * @description tracks recommendation counts for each severity level
 * @param {Record<string, number>} severityCounts - Object with severity names as keys and recommendation counts as values
 * @example trackSuggestedRecommendationsBySeverity({ 'High': 2, 'Medium': 5, 'Low': 3 })
 */
export const trackSuggestedRecommendationsBySeverity = (
  severityCounts: Record<string, number>
) => {
  let questionIndex = 1;
  Object.entries(severityCounts).forEach(([severityName, count]) => {
    trackFormInput(
      ANALYTICS.SUGGESTED_RECOMMENDATIONS_FORM_NAME,
      ANALYTICS.STEP,
      severityName,
      count.toString(),
      questionIndex.toString()
    );
    questionIndex++;
  });
};

/**
 * @method trackSuggestedRecommendationsByChannel
 * @description tracks total recommendation count for the selected channel
 * @param {string} channelName - The selected channel name
 * @param {number} totalRecommendations - Total number of recommendations for this channel
 * @example trackSuggestedRecommendationsByChannel('email', 10)
 */
export const trackSuggestedRecommendationsByChannel = (
  channelName: string,
  totalRecommendations: number
) => {
  trackFormInput(
    ANALYTICS.SUGGESTED_RECOMMENDATIONS_FORM_NAME,
    ANALYTICS.STEP,
    channelName,
    totalRecommendations.toString(),
    '1'
  );
};

/**
 * @method trackSuggestedRecommendationsUserNtid
 * @description tracks the user encoded ntid for suggested recommendations
 * @param {string} userEncodedNtid - The encoded user ntid
 * @example trackSuggestedRecommendationsUserNtid('encoded-ntid-123')
 */
export const trackSuggestedRecommendationsUserNtid = (
  userEncodedNtid: string
) => {
  if (userEncodedNtid !== '') {
    trackFormInput(
      ANALYTICS.SUGGESTED_RECOMMENDATIONS_FORM_NAME,
      ANALYTICS.STEP,
      ANALYTICS.USER_ENCODED_NTID_QUESTION_NAME,
      userEncodedNtid,
      '1'
    );
  }
};
